import GameStepBase, {createGameFlowCancelResponse} from './game_step_base';
import _ from '../../../utils/underscore';

export default class RestrictionsGameStep extends GameStepBase {
    static CLASS = 'RestrictionsGameStep';

    init(params) {
        super.init(params);
        if(_.isNullOrUndefined(params.isReal)) {
            this.throwArgumentExpected('10', 'init', 'isReal');
        }

        this._isReal = params.isReal;
    }

    run(gameOptions) {
        if(this._isReal) {
            return new Promise((resolve, reject) => {
                if(gameOptions.gameInfo.restriction.isGameAllowedToPlayReal()) {
                    resolve(gameOptions);
                } else {
                    reject(createGameFlowCancelResponse('Game restricted'));
                    this.logger.warn(`Game type ${gameOptions.gameType} is restricted`);
                    gameOptions.gameInfo.restriction.showUserMessage();
                }
            });
        }

        return Promise.resolve(gameOptions);


    }
}